import type { IconName } from '@/assets/icons/icons'
import type { CustomFieldType } from '@/services/domain/cusomFields/types'

export const customFieldIcons: Record<CustomFieldType, IconName> = {
  text: 'tmi-keywords',
  numeric: 'tmi-tag',
  monetary: 'tmi-money',
  date: 'event',
  dateTime: 'tmi-calendar-time',
  singleOption: 'radio_button_checked',
  multiOption: 'tmi-dropdown-form',
}
